module.exports = __webpack_public_path__ + "img/burundi.b36c9648.png";